export const dialogContentStyles = {
  paddingTop: 4,
  paddingBottom: { xs: 2.5, sm: 3 },
  height: '26rem',
  overflowY: 'scroll',
  width: {
    lg: '37.5rem',
    md: '37.5rem',
  },
}

export const actionButtonStyles = {
  paddingTop: { xs: 0, sm: 1.5 },
  paddingRight: 3,
  paddingBottom: 3,
  display: 'flex',
  justifyContent: { xs: 'space-between', sm: 'flex-end' },
  ml: { xs: '0.75rem' },
  height: '4.5rem',
}
